import { container } from '../../style/mixins'

export default ({ children, ...rest }) => <div {...container} {...rest}>{children}</div>



// WEBPACK FOOTER //
// ./src/components/container/index.js